/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ArchitectureInputIds } from '../models/ArchitectureInputIds';
import type { Body_import_concept_concepts_import_post } from '../models/Body_import_concept_concepts_import_post';
import type { ComponentInDB } from '../models/ComponentInDB';
import type { Concept } from '../models/Concept';
import type { ConceptCloneInput } from '../models/ConceptCloneInput';
import type { ConceptPopulated } from '../models/ConceptPopulated';
import type { ConceptSettings } from '../models/ConceptSettings';
import type { ConceptUpdate } from '../models/ConceptUpdate';
import type { ConfigurationInDB } from '../models/ConfigurationInDB';
import type { DriveCycleInDB } from '../models/DriveCycleInDB';
import type { ExchangeFile } from '../models/ExchangeFile';
import type { PartNames } from '../models/PartNames';
import type { Requirement } from '../models/Requirement';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ConceptsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create Concept Check
     * Create with additional checks.
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns Concept Successful Response
     * @throws ApiError
     */
    public createConceptCheckConceptsPost(
        requestBody: Concept,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Concept> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/concepts',
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read By Design Or Design Instance Ids
     * Get from ID.
     * @param designId
     * @param designInstanceId
     * @returns Concept Successful Response
     * @throws ApiError
     */
    public readByDesignOrDesignInstanceIdsConceptsGet(
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Concept> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/concepts',
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * @deprecated
     * Read By Design Or Design Instance Ids
     * Get from ID.
     * @param designInstanceId
     * @param designId
     * @returns Concept Successful Response
     * @throws ApiError
     */
    public readByDesignOrDesignInstanceIdsConceptsDesignInstanceIdGet(
        designInstanceId: (string | null),
        designId?: (string | null),
    ): Observable<Concept> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/concepts/{design_instance_id}',
            path: {
                'design_instance_id': designInstanceId,
            },
            query: {
                'design_id': designId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Or Update Design Instance Settings
     * Create or update Concept settings.
     * @param designIdentifier
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns ConceptSettings Successful Response
     * @throws ApiError
     */
    public createOrUpdateDesignInstanceSettingsConceptsDesignIdentifierSettingsPost(
        designIdentifier: string,
        requestBody: ConceptSettings,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ConceptSettings> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/concepts/{design_identifier}/settings',
            path: {
                'design_identifier': designIdentifier,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Design Instance Settings
     * Retrieve Concept settings, falling back to defaults if missing or incomplete.
     * @param designIdentifier
     * @param designId
     * @param designInstanceId
     * @returns ConceptSettings Successful Response
     * @throws ApiError
     */
    public getDesignInstanceSettingsConceptsDesignIdentifierSettingsGet(
        designIdentifier: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ConceptSettings> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/concepts/{design_identifier}/settings',
            path: {
                'design_identifier': designIdentifier,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Design Instance Settings
     * Delete Concept settings.
     * @param designIdentifier
     * @param designId
     * @param designInstanceId
     * @returns void
     * @throws ApiError
     */
    public deleteDesignInstanceSettingsConceptsDesignIdentifierSettingsDelete(
        designIdentifier: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/concepts/{design_identifier}/settings',
            path: {
                'design_identifier': designIdentifier,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Parts
     * Get the parts of a concept.
     * @param designIdentifier
     * @param partName
     * @param designId
     * @param designInstanceId
     * @param skip
     * @param limit
     * @returns any Successful Response
     * @throws ApiError
     */
    public listPartsConceptsDesignIdentifierPartNameGet(
        designIdentifier: string,
        partName: PartNames,
        designId?: (string | null),
        designInstanceId?: (string | null),
        skip?: number,
        limit: number = 100,
    ): Observable<(Array<(ArchitectureInputIds | ComponentInDB | ConfigurationInDB | Requirement | DriveCycleInDB)> | ArchitectureInputIds | ComponentInDB | ConfigurationInDB | Requirement | DriveCycleInDB | null)> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/concepts/{design_identifier}/{part_name}',
            path: {
                'design_identifier': designIdentifier,
                'part_name': partName,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
                'skip': skip,
                'limit': limit,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * Update with new parameters.
     * @param itemId
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns Concept Successful Response
     * @throws ApiError
     */
    public updateConceptsItemIdPatch(
        itemId: string,
        requestBody: ConceptUpdate,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<Concept> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/concepts/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete
     * Delete by ID.
     * @param itemId
     * @param designId
     * @param designInstanceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteConceptsItemIdDelete(
        itemId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/concepts/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy
     * Clone Concept.
     * @param populated
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public copyConceptsCopyPost(
        populated: boolean,
        requestBody: ConceptCloneInput,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<(ConceptPopulated | Concept)> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/concepts:copy',
            query: {
                'populated': populated,
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Concept
     * Export Concept to Exchange File.
     * @param getJobs
     * @param getS3Files
     * @param designId
     * @param designInstanceId
     * @returns ExchangeFile Successful Response
     * @throws ApiError
     */
    public exportConceptConceptsExportGet(
        getJobs: boolean = false,
        getS3Files: boolean = true,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ExchangeFile> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/concepts:export',
            query: {
                'get_jobs': getJobs,
                'get_s3_files': getS3Files,
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Concept
     * Import Concept from Exchange File.
     * @param designId
     * @param projectId
     * @param formData
     * @param designInstanceId
     * @returns Concept Successful Response
     * @throws ApiError
     */
    public importConceptConceptsImportPost(
        designId: string,
        projectId: string,
        formData: Body_import_concept_concepts_import_post,
        designInstanceId?: (string | null),
    ): Observable<Concept> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/concepts:import',
            query: {
                'design_id': designId,
                'project_id': projectId,
                'design_instance_id': designInstanceId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
}
